import type { SVGProps } from 'react';

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill={props.fill ?? 'none'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1826 0.0322782C16.4831 0.435778 11.8594 2.31668 8.34864 5.25318C4.36404 8.58598 1.61654 13.0823 0.539936 18.0321C-0.648464 23.4961 0.134736 29.0476 2.79214 33.9971C4.90464 37.9318 8.28724 41.2642 12.3493 43.4125C16.9259 45.833 22.4565 46.6194 27.5996 45.5811C31.1779 44.8587 34.9431 43.0614 37.6946 40.7624L38.2106 40.3312L46.1576 48.2702C54.927 57.0308 54.2951 56.4538 55.0587 56.3986C55.8017 56.3449 56.3644 55.7822 56.4181 55.0392C56.4733 54.2756 57.0504 54.9075 48.2889 46.1373L40.349 38.1894L40.8427 37.5813C43.8221 33.9108 45.4702 29.879 45.9576 25.0691C46.0551 24.1059 46.0553 21.6729 45.9578 20.7601C45.2977 14.5769 42.303 9.00108 37.5816 5.16458C33.3384 1.71658 28.3199 -0.0396218 22.8256 0.00067817C22.0584 0.00627817 21.319 0.0204782 21.1826 0.0322782ZM22.0196 3.00778C17.6482 3.24748 13.4188 4.92208 10.0941 7.72958C7.14574 10.2192 4.82024 13.8088 3.80134 17.4431C2.83714 20.8821 2.76124 24.4527 3.58254 27.7351C5.09914 33.7959 9.14704 38.6704 14.8017 41.2451C18.4474 42.9051 22.7961 43.4274 26.7409 42.679C29.5538 42.1455 32.5288 40.8512 34.8536 39.1498C36.4255 37.9994 37.9205 36.501 39.1516 34.8423C42.303 30.5957 43.6291 25.1265 42.7874 19.847C42.1173 15.6441 40.03 11.6098 37.0284 8.71588C33.4189 5.23588 29.1248 3.34358 24.1276 3.03068C23.1517 2.96958 22.7869 2.96568 22.0196 3.00778Z"
        fill={props.fill ?? '#F76161'}
      />
    </svg>
  );
}
